const config = {
  apis: {
    baseDivio: "https://voterguide-stage.us.aldryn.io/en/api/v1", // API Server
    base: "https://api-2022-a.theoregonvoterguide.com/api/", // API Server
    baseDev: "https://api-2022-a.theoregonvoterguide.com/api/", // API Server
    baseEB: "http://voterguidecms-dev.us-east-1.elasticbeanstalk.com/api/v1", // API Server
    baseImage: "https://api-2022-a.theoregonvoterguide.com", // API Image base
    localHost: "http://localhost:8000//en/api/v1", // API localhost for dev
    pages: "v1/pages/", // Endpoint for serialized pages
    races: "v1/racepage/", // Endpoint for serialized races,
    amendments: "v1/amendmentpage/?filters=(is_statewide=true)", //Endpoint for amendments
    amendmentsAll: "v1/amendmentpage/", //List all amendments
    crmproxy: "/.netlify/functions/crm", // CRM API proxy,
    crmurl: "https://api.myngp.com/v2/forms/-1176499224585171968", // CRM API
    ballotFilters:
      "(is_statewide=true) | (geography_id=state_house_{sldl}) | (geography_id=state_senate_{sldu}) | (geography_id=us_congress_{cd}) | (geography_id=county_{county})", // Filters for ballot
    raceFilters: "(race_name={race})", // Filters for race
    targetSmartAPI: "/api/district?address=", //Target Smart API
  },
  gaTrackingId: "",
  tabs: {
    affordability: "Affordability",
    data_centers: "Data Centers",
    education: "Education",
    food_assistance: "Food Assistance",
    healthcare: "Healthcare",
    abortion: "Abortion",
    environment_climate: "Environment & Climate",
    homelessness_housing: "Homelessness & Housing",
    democracy: "Democracy",
    vote_by_mail: "Vote by Mail",
    taxes: "Taxes",
    ice: "ICE",
  },
  tabsES: {
    es_affordability: "Asequibilidad",
    es_data_centers: "Centros de datos",
    es_education: "Educación",
    es_food_assistance: "Asistencia alimentaria",
    es_healthcare: "Salud",
    es_abortion: "Aborto",
    es_environment_climate: "Medioambiente y situación climática",
    es_homelessness_housing: "Vivienda e indigencia",
    es_democracy: "Democracia",
    es_vote_by_mail: "Voto por correo",
    es_taxes: "Impuestos",
    es_ice: "ICE",
  },
  senate_house_mapping: {
    state_senate_4: ["state_house_7"],
    state_senate_5: ["state_house_9", "state_house_10"],
    state_senate_10: ["state_house_19", "state_house_20"],
    state_senate_11: ["state_house_21", "state_house_22"],
    state_senate_13: ["state_house_26"],
    state_senate_20: ["state_house_39", "state_house_40"],
    state_senate_24: ["state_house_48"],
    state_senate_25: ["state_house_49", "state_house_50"],
    state_senate_27: ["state_house_53", "state_house_54"],
    no_senate: ["state_house_32", "state_house_52"]
  },
}

export default config
